import { fetchConversation } from '@app/api'
import { getMessages, initialConversationItem } from '@app/helpers'

import { UnknownThreadEventCapturedPayload } from '@app/hooks'
import { handleForbiddenConversationError } from '@app/utils'

import { logger } from '@lib/utils'

import type { CreateOnChatThreadCreatedParams } from './types'
import type { ChatThreadCreatedEvent } from '@azure/communication-chat'

export const createOnChatThreadCreated = ({
  dispatch,
  getDependencies,
  unreadEnabled,
  currentUserId,
  onConversationForbidden,
}: CreateOnChatThreadCreatedParams) => {
  return async (event: ChatThreadCreatedEvent) => {
    logger('onChatThreadCreated', event, '#c203fc')

    let conversation: Awaited<ReturnType<typeof fetchConversation>>
    try {
      conversation = await fetchConversation(event.threadId)
    } catch (error) {
      if (handleForbiddenConversationError(error, onConversationForbidden)) {
        return
      }

      throw error
    }

    const { listings, accounts } = await getDependencies([conversation])

    const messages = getMessages(conversation.lastMessage)

    const isCreatedByCurrentUser = conversation.participants?.some(
      (item) =>
        item.id === conversation.lastMessage?.fromParticipantId &&
        item.userId === currentUserId
    )

    const payload: UnknownThreadEventCapturedPayload = {
      listings,
      accounts,
      conversation: {
        ...initialConversationItem,
        ...conversation,
        messages,
        total: 0,
        unread: unreadEnabled && !isCreatedByCurrentUser,
      },
    }

    dispatch({
      type: 'UNKNOWN_THREAD_EVENT_CAPTURED',
      payload,
    })
  }
}
